import { useTranslation } from "react-i18next";
import { FoodsIconButton } from "@foodpilot/foods";
import { getApiUrl } from "src/api/axiosClient/utils";
import { CompaniesService } from "src/services/Companies/CompaniesService";
import { buildPostPdfReportUrl } from "./postPdfReportUrl";

type Props = {
    postId: number | undefined;
    scoreId: number | string;
};
export const ExportPdfButton = (props: Props) => {
    const { t } = useTranslation();

    const { postId, scoreId } = props;

    // Ne pas rendre le bouton si postId est invalide
    if (!postId) {
        return null;
    }

    const dynamicPdfExportUri = buildPostPdfReportUrl({
        apiUrl: getApiUrl(),
        postId,
        scoreId,
        organizationId: CompaniesService.getCurrentCompanyId(),
    });

    return (
        <FoodsIconButton
            size={"s"}
            icon={"exportDownload"}
            withBackground
            buttonProps={{
                href: dynamicPdfExportUri,
                target: "_blank",
            }}
            tooltip={{
                text: t("pdf.download_one_questionnaire_report", "Download report"),
                props: {
                    placement: "bottom",
                },
            }}
        />
    );
};
